// extracted by mini-css-extract-plugin
export default {"root":"AmountContainerDiv_root__6i0cE"};